import ServiceGraphQL from 'src/service/gql-service';
import { createCustomer } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const CreateCustomer = (data) => {
  const params = {
    query: createCustomer.QUERY,
    variables: {
      record: data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
